import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { SkipLinksType, skipToMenuMappers } from '~shared/services/skip-to-menu.service';

@Component({
  selector: 'app-skip-to-menu',
  templateUrl: './skip-to-menu.component.html',
  styleUrls: ['./skip-to-menu.component.scss'],
})
export class SkipToMenuComponent implements OnInit, OnDestroy {
  menuLinks: SkipLinksType[] = [];
  private unsub$ = new Subject();
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.events
      .pipe(
        takeUntil(this.unsub$),
        filter((event) => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        this.menuLinks =
          skipToMenuMappers.find((v) => v.getPage(event.url) || v.getPage(event.urlAfterRedirects))?.links ?? [];
      });
  }

  handleScroll(targetId: string, event: MouseEvent) {
    event.preventDefault();

    const targetElement = document.getElementById(targetId);
    const defaultMargin = 20;

    if (targetElement) {
      const top = targetElement.offsetTop - defaultMargin;

      window.scrollTo({
        top,
        behavior: 'smooth',
      });

      targetElement.setAttribute('tabIndex', '-1');
      targetElement.focus();
    }
  }

  ngOnDestroy(): void {
    this.menuLinks = [];
    this.unsub$.next();
    this.unsub$.complete();
  }
}
